import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DialogContentComponent, DialogSpinnerComponent } from './alert/alert.component';
const appRoutes: Routes = [
    { path: 'dialog-content', component: DialogContentComponent },
    { path: 'dialog-spinner', component: DialogSpinnerComponent },

];
export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);
